import state from './moduleZISState.js'
import mutations from './moduleZISMutations.js'
import actions from './moduleZISActions.js'
import getters from './moduleZISGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
